import { css } from "@emotion/react";
import { Box, Typography } from "@mui/material";
import React from "react";
import { PiWarningCircle } from "react-icons/pi";

type Props = {
  /** 既定は認証コードの誤り・期限切れの案内 */
  message?: string;
};

const SecurityWarning: React.FC<Props> = ({ message }) => {
  return (
    <Box p={2} mt={2} css={style.container}>
      <Box display="flex" alignItems="center" gap={0.5} mb={1}>
        <PiWarningCircle size={24} />
        <Typography css={style.title}>認証に失敗しました</Typography>
      </Box>
      <Typography css={style.description}>
        {message ??
          "認証コードの有効期限が切れているか、認証コードが誤っている可能性がございます。もう一度やり直してください。"}
      </Typography>
    </Box>
  );
};
export default React.memo(SecurityWarning);

const style = {
  container: css`
    width: 100%;
    border: 1px solid #ff5555;
    border-radius: 8px;
    color: #ff5555;
    background-color: #fff7f6;
  `,
  title: css`
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
  `,
  description: css`
    font-weight: 500;
    color: #596171;
    font-size: 13px;
    line-height: 1.5;
  `,
};
